export default __webpack_public_path__ + "static/media/urgent-care-now-4.dc8883ef.svg";